export const Roles = {
  ADMIN: 'Admin',
  DISPATCH: 'Dispatch',
  MOBILE_USER: 'Mobile User',
};

const acceptedRoles = [Roles.ADMIN, Roles.DISPATCH, Roles.MOBILE_USER];

export function isRoleAccepted(userRole) {
  return acceptedRoles.includes(userRole);
}

export function isAdmin(userRole) {
  return userRole === Roles.ADMIN;
}

export function isDispatch(userRole) {
  return userRole === Roles.DISPATCH;
}

export function isMobileUser(userRole) {
  return userRole === Roles.MOBILE_USER;
}
